var _defs, _path, _mask;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconOthersNew(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "icon_others_new_svg__a",
    d: "M0 32h32V0H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M25.03 15.721l-1.02-1.02c-.264-.264-.785-.48-1.157-.48H17.68c-.372 0-.894.216-1.158.48l-1.02 1.02-3.812 3.812-.001.002a1.43 1.43 0 00-.264 1.653c.068.136.152.265.265.379.112.112.242.197.378.264a1.433 1.433 0 001.654-.264l2.8-2.802c.264-.264.48-.173.48.2v4.988c0 .322.23.58.532.65v.029h5.464v-.03a.672.672 0 00.532-.649v-4.988c0-.373.216-.464.48-.2l2.8 2.802c.45.448 1.118.532 1.656.264.135-.068.264-.152.376-.264a1.43 1.43 0 00.266-.379 1.431 1.431 0 00-.266-1.655l-3.812-3.812zM22.166 13.213c.673-.717 1.006-1.323 1.006-2.936a2.791 2.791 0 00-2.905-2.907 2.79 2.79 0 00-2.907 2.907c0 1.613.334 2.219 1.007 2.936.619.45 1.276.515 1.9.515.623 0 1.28-.064 1.899-.515M10.399 17.402H9.065c0-.607-.606-1.102-1.353-1.102-.745 0-1.352.495-1.352 1.102H5.027c0-1.343 1.204-2.435 2.685-2.435 1.483 0 2.687 1.092 2.687 2.435",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.092 18.068h-1.056v6.564h1.056a.67.67 0 00.667-.664v-5.236a.67.67 0 00-.667-.664",
    fill: props.color
  }), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "icon_others_new_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#icon_others_new_svg__a"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    mask: "url(#icon_others_new_svg__b)",
    d: "M5.23 24.632h4.966v-6.564H5.229zM3.334 18.068c-.368 0-.667.3-.667.667v5.23c0 .367.299.667.667.667H4.39v-6.564H3.334z"
  })));
}

export default SvgIconOthersNew;